<template>
  <b-overlay
    :show="isLoading"
    variant="transparent"
    opacity="0.99"
    blur="5px"
  >
    <template #overlay>
      <div class="text-center">
        <b-icon-controller
          font-scale="3"
          animation="cylon"
        />
        <p>กรุณารอสักครู่...</p>
      </div>
    </template>

    <b-card no-body>
      <b-card-body v-if="form">
        <b-form @submit.prevent="submit">
          <!-- Header -->
          <div class="d-flex justify-content-between align-items-center mb-4">
            <div>
              <p class="text-danger mb-1">
                ปิด - เปิด ระบบชวนเพื่อน
              </p>
              <b-form-checkbox
                v-model="form.is_enabled"
                class="custom-control-primary"
                switch
              >
                <span class="switch-icon-left"><feather-icon icon="CheckIcon" /></span>
                <span class="switch-icon-right"><feather-icon icon="XIcon" /></span>
              </b-form-checkbox>
            </div>

            <b-button
              variant="success"
              type="submit"
              :disabled="isSaving"
            >
              {{ isSaving ? 'กำลังบันทึก...' : 'บันทึกข้อมูล' }}
            </b-button>
          </div>

          <b-alert
            v-if="serverErrors.length"
            show
            variant="danger"
            class="mb-3"
          >
            <strong>Validation Error</strong>
            <ul class="mb-0 pl-3">
              <li
                v-for="(err, i) in serverErrors"
                :key="i"
              >
                {{ err }}
              </li>
            </ul>
          </b-alert>

          <div class="row">
            <div
              v-for="n in 5"
              :key="n"
              class="col-md-6 mb-3"
            >
              <b-form-group :label="`เปอร์เซ็นต์ ชั้นที่ ${n}`">
                <div class="d-flex align-items-center">
                  <b-form-input
                    v-model.number="form[`level${n}_pct`]"
                    type="number"
                    min="0"
                    max="100"
                    step="0.01"
                    required
                    class="mr-2"
                  />
                  <span>%</span>
                </div>
              </b-form-group>
            </div>
          </div>
        </b-form>
      </b-card-body>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BForm,
  BButton,
  BCard,
  BCardBody,
  BFormGroup,
  BFormInput,
  BOverlay,
  BIconController,
  BFormCheckbox,
  BAlert,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BForm,
    BButton,
    BCard,
    BCardBody,
    BFormGroup,
    BFormInput,
    BOverlay,
    BIconController,
    BFormCheckbox,
    BAlert,
  },
  directives: { Ripple },
  data: () => ({
    form: null,
    isLoading: false,
    isSaving: false,
    serverErrors: [],
  }),
  mounted() {
    this.getSetting()
  },
  methods: {
    async getSetting() {
      this.isLoading = true
      try {
        const { data } = await this.$http.get('/referral/show')
        this.form = data?.data || {
          is_enabled: true,
          level1_pct: 0,
          level2_pct: 0,
          level3_pct: 0,
          level4_pct: 0,
          level5_pct: 0,
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.isLoading = false
      }
    },
    async submit() {
      this.isSaving = true
      this.serverErrors = []
      try {
        // eslint-disable-next-line no-plusplus
        for (let i = 1; i <= 5; i++) {
          const val = this.form[`level${i}_pct`]
          if (val < 0 || val > 100) {
            this.serverErrors.push(`เปอร์เซ็นต์ ชั้น ${i} ต้องอยู่ในช่วง 0–100`)
          }
        }
        if (this.serverErrors.length) {
          this.isSaving = false
          return
        }

        const { data } = await this.$http.post('/referral/update', this.form)
        if (data?.code === 0) {
          await this.$swal({
            icon: 'success',
            title: '<h3 style="color:#141414">บันทึกสำเร็จ</h3>',
            text: 'บันทึกข้อมูลเรียบร้อยแล้ว',
            customClass: { confirmButton: 'btn btn-success' },
          })
        }
      } catch (err) {
        console.error(err)
      } finally {
        this.isSaving = false
      }
    },
  },
}
</script>
